import { KeyValuePipe, NgClass } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormResponseService } from '../form-response.service';
import { LegendPipe } from '../legend.pipe';
import { IQuesField } from '../multi-section-form-preview.models';
import { MultiSectionFormPreviewService } from '../multi-section-form-preview.service';

@Component({
  selector: 'app-list-sections-and-fields',
  templateUrl: './list-sections-and-fields.component.html',
  styleUrls: ['./list-sections-and-fields.component.css'],
  standalone: true,
  imports: [NgClass, KeyValuePipe, LegendPipe],
})
export class ListSectionsAndFieldsComponent implements OnInit {
  public msfps = inject(MultiSectionFormPreviewService);
  public fr = inject(FormResponseService);

  asIsOrder(a, b) {
    return 1;
  }

  ngOnInit() {

    if (this.msfps.getFirstActiveSecAndSubSec().DisplayType === 'One') {
      this.msfps.showSectionFieldPreview(
        this.msfps.getFirstFieldFromActiveSecOrSubSec(),
      );
    } else {
      this.msfps.showEntireSectionPreview(
        this.msfps.getFirstActiveSecAndSubSec().UniqueID,
      );
    }
    this.msfps.helper$.subscribe((helper) => {
      if (
        helper.val === 'clicked on preview question input element' ||
        helper.val === 'set on preview question input element'
      ) {
        const triggerSubjectAction =
          helper.val === 'clicked on preview question input element'
            ? 'clickAction'
            : helper.val === 'set on preview question input element'
              ? 'setAction'
              : null;
        if (this.msfps.toggleIndividualSectionFieldPreviewMode) {
          const field: IQuesField = this.msfps.getCurrentPreview();
          if (field && Object.keys(field)?.length) {
            this.fr.handleResponse(field, triggerSubjectAction);
          }
        } else {
          const activeSubSectionId = Object.keys(
            this.msfps.getCurrentPreview(),
          )[0];
          const fieldsList: IQuesField[] =
            this.msfps.getCurrentPreview()[activeSubSectionId].fieldsList;
          const activeField = fieldsList?.find(
            (f) => f.data[0].QuestionId === helper.activeQuestionId,
          );

          this.msfps.activeFieldInfo = activeField;

          if (activeField && Object.keys(activeField)?.length) {
            this.fr.handleResponse(activeField, triggerSubjectAction);
          }
        }
      }
    });
  }

  preview(field: IQuesField) {
    this.msfps.scrollFieldIntoView$ = field;
    this.msfps.toggleIndividualSectionFieldPreviewMode =
      this.msfps.getSection(field.sectionId).DisplayType === 'One';

    this.msfps.showSectionFieldPreview(field);
    this.msfps.activeFieldInfo = field;
  }
}
